import { InsightsGeneratorHelper } from '../insights-generator/insights-generator.helper';

export class MarkdownPayloadHelper {
  static storeTableAsMarkdown(component: any): void {
    if (component.tableOutputComponent) {
      const markdown = component.tableOutputComponent.extractMarkdownTable();
      if (markdown) {
        component.insights_payload = markdown;
      }
    } else {
      console.warn('[Crosstab Markdown] tableOutputComponent is not initialized or rendered yet.');
    }
  }

  static buildSnapshotMarkdown(component: any): void {
    try {
      const md = InsightsGeneratorHelper.buildSnapshotMarkdownFromWidget(
        component.filteredWidgetData
      );
      component.snapshotinsights_payload = md;

      // Handle trendline data if available
      if (component.filteredWidgetData?.trendline_response) {
        console.log('[MarkdownPayloadHelper] Building Trendline Snapshot Markdown...');
        const trendMd = InsightsGeneratorHelper.buildTrendSnapshotMarkdownFromWidget(
          component.filteredWidgetData
        );
        component.snapshotinsights_trend_payload = trendMd;
        console.log('[MarkdownPayloadHelper] Trendline Markdown Generated:', { length: trendMd?.length });
      }
    } catch (err) {
      console.error('[Snapshot Markdown] Error:', err);
    }
  }

  static buildTrendSnapshotMarkdown(component: any): void {
    try {
      console.log('[MarkdownPayloadHelper] Building Trendline Snapshot Markdown (Manual Call)...');
      const md = InsightsGeneratorHelper.buildTrendSnapshotMarkdownFromWidget(
        component.filteredWidgetData
      );
      component.snapshotinsights_trend_payload = md;
      console.log('[MarkdownPayloadHelper] Trendline Snapshot Markdown Generated:', { length: md?.length });
    } catch (err) {
      console.error('[Trend Snapshot Markdown] Error:', err);
    }
  }

  static async buildMarkdownPayload(component: any, isTrend: boolean = false): Promise<any> {
    try {
      console.log('[MarkdownPayloadHelper] Acquiring Bearer Token and Building Payload...', { isTrend });
      const token = await component.getBearerToken();
      const isSnapshot = component.mcode === 1;

      const basePayload: any = {
        client_name: component.selected_client || component.landingdata?.client_code || '',
        study: component.selected_study || component.landingdata?.study || '',
        session_id: component.guidChatId,
        bearer_token: token,
        markdown: isSnapshot
          ? (isTrend ? component.snapshotinsights_trend_payload : component.snapshotinsights_payload)
          : component.insights_payload,
        mcode: component.mcode,
        query: component.inputValue,
        debug_mode: false
      };

      if (isSnapshot) {
        basePayload.selected_doc_id = component.chatPayload?.selected_doc_id || component.promptData?.selected_doc_id || '';

        if (component.filteredWidgetData) {
          basePayload['widget_details'] = {
            widget_name: component.filteredWidgetData.widget_name || '',
            widget_id: component.filteredWidgetID || '',
            widgetchart_name: component.filteredWidgetData.widgetchart_name || '',
            Snapshot_Name: component.Snapshotdataforexport?.snapshotName || '',
            Snapshot_Type: component._configService.selectedSnapshotType || '',
            Section: component.selectedSection
          };
        }
      }


      return basePayload;

    } catch (err) {
      console.error('[Markdown Payload] Error building payload:', err);
      return null;
    }
  }
}
